import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { map }        from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Class } from '../models/class.model';

@Injectable({
    providedIn: 'root'
})
export class ClassService {

    private apiURL : string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/class';

    }

    getByEditionAndStudentAge(editionId: number, studentYear: number): any {

        const url = this.apiURL + '/edition/' + editionId + '/year/' + studentYear;
        return this.http.get<Class[]>(url);

    }

}
